
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web/password_forgot",
      function () {
        return require("private-next-pages/web/password_forgot.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/web/password_forgot"])
      });
    }
  